<template>
    <div>
        <h3 class="mb-0">Insurance Details</h3>
        <b-form role="form" class="mt-4" @submit.prevent="addInsurance">
            <b-row>
                <b-col md="8" cols="12">
                    <b-form-group label="Insurance Type">
                        <b-form-radio-group
                            required
                            v-model="form.product_type"
                            :options="productOptions"
                        ></b-form-radio-group>
                    </b-form-group>
                </b-col>
                
                <b-col md="8" cols="12">
                    <b-form-group label="Package">
                        <el-select v-model="form.package_name" placeholder="Select">
                            <el-option
                                v-for="(item, index) in packageOptions"
                                :key="index"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                
                <b-col md="8" cols="12">
                    <b-form-group label="Company">
                        <el-select v-model="form.company_name" placeholder="Select">
                            <el-option
                                v-for="(item, index) in companyOptions"
                                :key="index"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                
                <b-col md="8" cols="12">
                    <b-form-group label="Premium p.a (RM)">
                        <CurrencyInput
                            v-model="form.premium_pa"
                            :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                        />
                    </b-form-group>
                </b-col>
                
                <b-col md="8" cols="12">
                    <b-form-group label="Premium p.m (RM)">
                        <CurrencyInput
                            v-model="form.premium_pm"
                            :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                        />
                    </b-form-group>
                </b-col>
                
                <b-col md="8" cols="12">
                    <b-form-group label="Premium Cover (RM)">
                        <CurrencyInput
                            v-model="form.premium_cover"
                            :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                        />
                    </b-form-group>
                </b-col>
                
                <b-col md="8" cols="12">
                    <b-form-group label="Paid By">
                        <el-select v-model="form.paid_by" placeholder="Select">
                            <el-option
                                v-for="(item, index) in paymentOptions"
                                :key="index"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </b-form-group>
                </b-col>

                <b-col md="8" cols="12">
                    <b-button block variant="primary" class="mb-5" type="submit">Add</b-button>
                </b-col>
            </b-row>
        </b-form>
    </div>
</template>
<script>
import { Select, Option, RadioGroup, RadioButton } from 'element-ui'
import solutionEventBus from '@/assets/js/EventBus/solutionEventBus.js'
import CurrencyInput from '@/components/CurrencyInput'
import {
notifyFunctionMixin
} from '@/assets/js/httpImports.js'
import { mapActions } from 'pinia'
import { useProductStore } from '@/stores/productStore'

export default {
    mixins:[
        notifyFunctionMixin,
    ],
    components: {
        CurrencyInput,
        [Select.name]: Select,
        [Option.name]: Option,
        [RadioGroup.name]: RadioGroup,
        [RadioButton.name]: RadioButton,
    },
    data() {
        return {
            form: {
                product_type: '',
                package_name: '',
                company_name: '',
                premium_pa: 0,
                premium_pm: 0,
                premium_cover: 0,
                paid_by: ''
            },
            productOptions: [
                { text: 'Investment Link', value: 'INVESTMENT_LINK' },
                { text: 'Life Insurance', value: 'LIFE_INSURANCE' }
            ],
            packageOptions: [
            {
                    value: 'Sunwira',
                    label: 'Sunwira'
                },
                {
                    value: 'Sun eSsential Life',
                    label: 'Sun eSsential Life'
                },
                {
                    value: 'Sun eSsential-i',
                    label: 'Sun eSsential-i'
                },
                {
                    value: 'Sun Legacy-i',
                    label: 'Sun Legacy-i'
                },
                {
                    value: 'Sun Prime Link-i',
                    label: 'Sun Prime Link-i'
                },
                {
                    value: 'Sun Wira',
                    label: 'Sun Wira'
                },
                {
                    value: 'Sun Heritage-i',
                    label: 'Sun Heritage-i'
                },
                {
                    value: 'Sun - Essentian-i',
                    label: 'Sun - Essentian-i'
                },
                {
                    value: 'FWD Insurance - 20 Years',
                    label: 'FWD Insurance - 20 Years',
                },
                {
                    value: 'FWD Insurance - 10 Years',
                    label: 'FWD Insurance - 10 Years',
                },
                {
                    value: 'Invinity Insurance',
                    label: 'Invinity Insurance',
                },
                {
                    value: 'MRTT',
                    label: 'MRTT',
                },
                {
                    value: 'MLTT',
                    label: 'MLTT',
                },
            ],
            companyOptions: [
                {
                    value: 'Sunlife',
                    label: 'Sunlife'
                },
                {
                    value: 'Manulife',
                    label: 'Manulife'
                },
                {
                    value: 'FWD Insurance BSN',
                    label: 'FWD Insurance BSN'
                },
            ],
            paymentOptions: [
                {
                    value: 'Credit Card - Auto Debit',
                    label: 'Credit Card - Auto Debit'
                },
                {
                    value: 'Transfer Bank',
                    label: 'Transfer Bank'
                },
                {
                    value: 'Cheques',
                    label: 'Cheques'
                },
                {
                    value: 'Cash',
                    label: 'Cash'
                },
                {
                    value: 'Payment Getaway',
                    label: 'Payment Getaway'
                },
                {
                    value: 'Auto debit from debit card',
                    label: 'Auto debit from debit card'
                },
                {
                    value: 'Not Applicable',
                    label: 'Not Applicable'
                },                {
                    value: 'Standard Instruction',
                    label: 'Standard Instruction'
                },
            ],
        }
    },
    watch:{
        'form.premium_pa':{
            handler(newVal){
                this.form.premium_pm = parseFloat(newVal) / 12
            }
        }
    },
    methods: {
        ...mapActions(useProductStore, ['createInsuranceProduct']),
        resetForm(){
            this.form.product_type = '',
            this.form.package_name = '',
            this.form.company_name = '',
            this.form.premium_pa = 0,
            this.form.premium_pm = 0,
            this.form.premium_cover = 0,
            this.form.paid_by = ''
        },
        async addInsurance(){
            if(this.form.package_name === '' || this.form.company_name === '' || this.form.paid_by === ''){
                this.errorFunction(null, 'Please fill in all the details.')
                return
            }

            const insurance = {
                prod_ins_type: this.form.product_type,
                prod_ins_package:this.form.package_name,
                prod_ins_company:this.form.company_name,
                prod_ins_premium_pa:this.form.premium_pa,
                prod_ins_premium_pm:this.form.premium_pm,
                prod_ins_premium_cover:this.form.premium_cover,
                prod_ins_paid_by:this.form.paid_by
            }

            useProductStore().$patch((state) => {
                state.current_product_data = { 
                    ...state.current_product_data, 
                    insurance: insurance
                }
            })

            try{
                await this.createInsuranceProduct()
                this.notifySuccess('<b>Draft </b> - Successfully Created.')
                this.resetForm()
                solutionEventBus.$emit('show-insurance-summary')
            }catch(e){
                this.errorFunction(null, e)
            }
        },
        preventNonNumericInput(event) {
            const keyCode = event.keyCode || event.which;
            const keyValue = String.fromCharCode(keyCode);
            const currencyRegex = /^[\d.,$]+(\.[\d.,$]+)?$/;
            const allowedKeys = [8, 37, 38, 39, 40, 46];
            if (keyCode !== 190 && !currencyRegex.test(keyValue) && !allowedKeys.includes(keyCode)) {
                event.preventDefault();
            }
        },
        emitEvent(eventName) {
            solutionEventBus.$emit(eventName)
        },
    }
}
</script>